/**Packages */
import axios from 'axios';

/**
 * 
 * @param {string} message - body message 
 * @param {string} simulatorType - simulator type
 * @returns {Promise<boolean>} true when log is successfully registered, otherwise false
 */
export const grafanaLog = async (message = "", simulatorType = "") => {
    const applicationName = `${simulatorType.toUpperCase()}${process.env.REACT_APP_ENVIRONMENT === 'production' ? '' : `-${process.env.REACT_APP_ENVIRONMENT}`}`, 
        configuration = {
            headers: {
                'Content-Type': 'application/json',
                'X-Forward-To': 'logger',
                'X-Application-Name': applicationName.toUpperCase()
            },
        },
        fullUrl = `${process.env.REACT_APP_RESILIENZA_URL}`;

    try {
        const result = await axios.post(fullUrl, {
            message
        }, configuration);
    
        return result && result.status === 200;
    } catch(err) {
        console.log("error in grafanaLog");
        console.log(err);
        return false;
    }
}